/**
 * Shared placeholder defaults for contact fields on "create new" forms.
 *
 * Reasoning: when adding a new project / tender / employee / contact, the
 * phone or email is often not yet known. Rather than have each admin type
 * a different made-up value (which pollutes the CRM with inconsistent
 * junk), every form pre-fills the same well-known placeholder values that
 * are easy to spot and replace later.
 *
 *    Phone : 07777777777
 *    Email : test@email.co.uk
 *
 * Note for user-creation forms: email is the login credential and is
 * UNIQUE per user. The first user created with the default email will
 * save fine; a second one will be rejected by the backend until the admin
 * supplies a real address.
 */
export const PLACEHOLDER_PHONE = '07777777777';
export const PLACEHOLDER_EMAIL = 'test@email.co.uk';
